import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { SWRConfig } from "swr";
import { Provider } from "react-redux";
import { store } from "./lib/store/store";
import { takeSessionFromUrl } from "./lib/auth/session";

const root = ReactDOM.createRoot(document.getElementById("root") as Element);

// Before anything loads: trade the ?code= from the talent app for a session
// and take it out of the address bar (see src/lib/auth/session.ts)
takeSessionFromUrl().finally(() => {
  root.render(
    <React.StrictMode>
      <SWRConfig
        value={{
          onError: (error, key) => {
            if (error.status !== 403 && error.status !== 404) {
              // console.log('global_error', error)
              // We can send the error to Sentry,
              // or show a notification UI.
            }
          },
        }}
      >
        <Provider store={store}>
          {/* <PersistGate loading={<PageLoader />} persistor={persistor}> */}
          <App />
          {/* </PersistGate> */}
        </Provider>
      </SWRConfig>
    </React.StrictMode>
  );
});
